import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Visible 404. Meta (noindex, no canonical) is set by SEOWrapper because this
 * same HTML file is served for every unknown URL. A canonical here would
 * point all of those URLs at one address.
 */
const NotFound: React.FC = () => {
  return (
    <div className="min-h-[60vh] bg-white px-4 py-16">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Page not found</h1>
        <p className="text-lg text-gray-600 mb-8">
          This address is not a page on the Brown Tech website. The link may be
          out of date, or the page may have moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700"
          >
            Back to the homepage
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-6 py-3 rounded-md border border-gray-300 text-gray-800 font-medium hover:bg-gray-50"
          >
            Contact Brown Tech
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
